export const URL = {
    mb_wapi: "https://www.medibuddy.in/WAPI/",
    demystify_url: process.env.REACT_APP_DEMYSTIFY_URL,
}

export const profileType = {
    corporate: "Corporate",
    insurance: "insurance",
    dynamicSet: "dynamic-set"
}

export const caseListPaginationInfo = {
    paginationMode: "server",
    defaultPageNumber: 1,
    defaultPageSize: 100
}

export const roleType = {
    Admin: "Admin",
    QCuser: "QCuser",
    DEuser: "DEuser"
}

export const caseStatus = {
    allPending: "All",
    dataEntryPending: "Data Entry Pending",
    lisDataAvailable: "LIS Data Available",
    doctorEntryPending: "Doctor Entry Pending",
    qcPending: "QC Pending",
    incomplete: "INCOMPLETE",
    verified: "VERIFIED"
}

export const userType = {
    all: "All",
    unallocated: ""
}

export const caseDefaultFilters = {
    corporateCaseFilters: {
        profile: profileType.corporate,
        selectedEnterprise: "All",
    },
    profileFilters: {},
    insuranceCaseFilters: {
        profileName: profileType.dynamicSet,
        selectedEnterprise: "All",
    }
}

export const LAB_NAME = ["A.G Diagnostics Pvt Ltd"];

const constants = {}

export default constants;